var Operator = window.Operator || {};
Operator.blockEditors = Operator.blockEditors || {};

$.extend(Operator.blockEditors, {
    ArrayFilterBrickModel: function (opts) {
        var form = opts.editor.find('form');

        Operator.Layout.setupCollections(form);
    }
});